import layoutHeaderAside from '@/layout/header-aside';

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV);

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    redirect: {
      // name: 'attendance'
      name: 'schools'
    },
    component: layoutHeaderAside,
    children: [
      // 卡号管理
      {
        path: 'cardNumber',
        name: 'cardNumber',
        meta: {
          title: '卡号管理',
          auth: true
        },
        component: _import('ai/cardNumber')
      },
      {
        path: 'portrait',
        name: 'portrait',
        meta: {
          // title: '学生头像管理',
          title: '头像管理',
          auth: true
        },
        component: _import('ai/portrait')
      },
      // 考勤计划
      {
        path: 'attendacnePlan',
        name: 'attendacnePlan',
        meta: {
          title: '考勤计划',
          auth: true
        },
        component: _import('ai/plan')
      },
      // 特征值管理
      {
        path: 'faces',
        name: 'faces',
        meta: {
          // title: '学生头像管理',
          title: '头像管理',
          auth: true
        },
        component: _import('ai/faces')
      },
      // 自动点名
      {
        path: 'attendance',
        name: 'attendance',
        meta: {
          // title: '学生考勤统计',
          title: '考勤统计',
          auth: true
        },
        component: _import('ai/attendance')
      },
      {
        path: 'classDetail',
        name: 'classDetail',
        hidden: true,
        component: _import('ai/attendance/classDetail')
      },
      // 作息策略
      {
        path: 'rest',
        name: 'rest',
        meta: {
          title: '系统设置',
          auth: true
        },
        component: _import('ai/rest')
      },
      // 班级管理
      {
        path: 'class',
        name: 'class',
        meta: {
          title: '班级管理',
          auth: true
        },
        component: _import('ai/class')
      },
      // 学校管理
      {
        path: 'schools',
        name: 'schools',
        meta: {
          title: '学校管理',
          auth: true
        },
        component: _import('ai/schools')
      },
      // 应用管理
      {
        path: 'application',
        name: 'application',
        meta: {
          title: '应用管理',
          auth: true
        },
        component: _import('ai/application')
      },
      // 镜头管理
      {
        path: 'camera',
        name: 'camera',
        meta: {
          title: '镜头管理',
          auth: true
        },
        component: _import('ai/camera')
      },
      // 系统设置
      {
        path: 'setting',
        name: 'setting',
        meta: {
          title: '角色分配',
          auth: true
        },
        component: _import('ai/setting')
      },
      // 统计
      {
        path: 'dataReport',
        name: 'dataReport',
        meta: {
          title: '数据统计',
          auth: true
        },
        component: _import('ai/dataReport')
      },
      {
        path: 'schools/:aUuid/:name',
        name: 'schoolDetail',
        hidden: true,
        component: _import('ai/schools/details')
      },
      // 课堂分析
      {
        path: 'studyAnalysis',
        name: 'studyAnalysis',
        meta: {
          title: '学生行为统计',
          auth: true
        },
        component: _import('ai/studyAnalysis')
      },
      // 系统 前端日志
      {
        path: 'log',
        name: 'log',
        meta: {
          title: '前端日志',
          auth: true
        },
        component: _import('system/log')
      },
      // 刷新页面 必须保留
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: _import('system/function/refresh')
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: _import('system/function/redirect')
      }
    ]
  }
];

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: _import('system/login')
  },
  {
    path: '/logout',
    name: 'logout',
    component: _import('system/login/logout')
  },
  {
    path: '/noAuth',
    name: 'noAuth',
    component: _import('system/login/noAuth')
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: _import('system/disclaimer/index')
  },
  {
    path: '/download',
    name: 'download',
    component: _import('ai/download/index')
  }
];

/**
 * 错误页面
 */
const errorPage = [
  {
    path: '*',
    name: '404',
    component: _import('system/error/404')
  }
];

// 导出需要显示菜单的
export const frameInRoutes = frameIn;

// 重新组织后导出
export default [...frameIn, ...frameOut, ...errorPage];
